
<template>
    <div class="center-on-page">
        <div class="signup-form-con">
            <router-link :to="{ name : $ROUTES.LOGIN }" class="has-text-centered">
                <div class="image logo" v-if="this.$store.state.dealer_portal.brandLogo">
                    <img :src="$srcOverwrite(this.$store.state.dealer_portal.brandLogo)"/>
                </div>
                <h1 class="title" v-if="!this.$store.state.dealer_portal.brandLogo">{{this.$store.state.dealer_portal.brandName}}</h1>
            </router-link>
            <form @submit="register">
                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input" :class="{ 'is-danger' : errors.has('email') }" type="email" placeholder="Email" v-model="payload.email" name="email" v-validate="'email|required'"/>
                        <span class="icon is-left">
                            <i class="fa fa-envelope"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</p>
                </div>
                <div class="columns is-no-pad-tb" style="margin-top:.75em;">
                    <div class="column">
                        <div class="field">
                            <div class="control">
                                <input class="input" :class="{ 'is-danger' : errors.has('first_name') }" type="text" placeholder="First Name" v-model="payload.firstName" name="first_name" v-validate="'required'"/>
                            </div>
                            <p v-show="errors.has('first_name')" class="help is-danger">{{ errors.first('first_name') }}</p>
                        </div>
                    </div>
                    <div class="column">
                        <div class="field">
                            <div class="control">
                                <input class="input" :class="{ 'is-danger' : errors.has('last_name') }" type="text" placeholder="Last Name" v-model="payload.lastName" name="last_name" v-validate="'required'"/>
                            </div>
                            <p v-show="errors.has('last_name')" class="help is-danger">{{ errors.first('last_name') }}</p>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input" :class="{ 'is-danger' : errors.has('password') }" type="password" placeholder="password" v-model="payload.password" name="password" v-validate="'required'"/>
                        <span class="icon is-left">
                            <i class="fa fa-user-secret"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</p>
                </div>
                <div class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('phone') }"
                            placeholder="Phone"
                            v-model="payload.phone"
                            name="phone"
                            v-validate="validation"
                        />
                        <span class="icon is-left">
                        <i class="fa fa-phone"></i>
                    </span>
                    </div>
                    <p v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</p>
                </div>
                <div class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('companyName') }"
                            placeholder="Company Name"
                            v-model="payload.companyName"
                            name="companyName"
                            v-validate="validation"
                        />
                        <span class="icon is-left">
                        <i class="fa fa-building"></i>
                    </span>
                    </div>
                    <p v-show="errors.has('companyName')" class="help is-danger">{{ errors.first('companyName') }}</p>
                </div>
                <!-- address1 start -->
                <div v-if="$store.state.dealer_portal.settings.require_business_information_on_sign_up" class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('address1') }"
                            placeholder="Address 1"
                            v-model="payload.addressLine1"
                            name="address1"
                            v-validate="'required'"
                        />
                        <span class="icon is-left">
                            <i class="fa fa-home"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('address1')" class="help is-danger">{{ errors.first('address1') }}</p>
                </div>
                <!-- address1 end-->
                <!-- address2 start-->
                <div v-if="$store.state.dealer_portal.settings.require_business_information_on_sign_up" class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('address2') }"
                            placeholder="Address 2"
                            v-model="payload.addressLine2"
                            name="address2"
                        />
                        <span class="icon is-left">
                            <i class="fa fa-home"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('address2')" class="help is-danger">{{ errors.first('address2') }}</p>
                </div>
                <!--address2 end-->
                <!-- city start -->
                <div v-if="$store.state.dealer_portal.settings.require_business_information_on_sign_up" class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('city') }"
                            placeholder="City"
                            v-model="payload.city"
                            name="city"
                            v-validate="'required'"
                        />
                    </div>
                    <p v-show="errors.has('city')" class="help is-danger">{{ errors.first('city') }}</p>
                </div>
                <!-- city end -->
                <!-- state start-->
                <div v-if="$store.state.dealer_portal.settings.require_business_information_on_sign_up" class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('state') }"
                            placeholder="State"
                            v-model="payload.state"
                            name="state"
                            v-validate="'required'"
                        />
                    </div>
                    <p v-show="errors.has('state')" class="help is-danger">{{ errors.first('state') }}</p>
                </div>
                <!-- state end -->
                <!-- Postal start-->
                <div v-if="$store.state.dealer_portal.settings.require_business_information_on_sign_up" class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('postal') }"
                            placeholder="Postal"
                            v-model="payload.postal"
                            name="postal"
                            v-validate="'required'"
                        />
                    </div>
                    <p v-show="errors.has('postal')" class="help is-danger">{{ errors.first('postal') }}</p>
                </div>
                <!-- Postal End -->
                <!-- country start -->
                <div v-if="$store.state.dealer_portal.settings.require_business_information_on_sign_up" class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('country') }"
                            placeholder="Country"
                            v-model="payload.country"
                            name="country"
                            v-validate="'required'"
                        />
                    </div>
                    <p v-show="errors.has('country')" class="help is-danger">{{ errors.first('country') }}</p>
                </div>
                <!-- country end -->
                <div v-if="$store.state.dealer_portal.settings.website" class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('website') }"
                            type="url"
                            placeholder="Your Website URL"
                            v-model="payload.website"
                            v-validate="$store.state.dealer_portal.settings.website_required ? 'required|url' : 'url'"
                            name="website"
                        />
                        <span class="icon is-left">
                        <i class="fa fa-globe"></i>
                    </span>
                    </div>
                    <p v-show="errors.has('website')" class="help is-danger">{{ errors.first('website') }}</p>
                </div>
                <div v-if="$store.state.dealer_portal.settings.collect_tax_id" class="field">
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('taxId') }"
                            placeholder="Your Tax ID"
                            v-model="payload.taxId"
                            v-validate="$store.state.dealer_portal.settings.collect_tax_id_required ? 'required' : null"
                            name="taxId"
                        />
                        <span class="icon is-left">
                        <i class="fa fa-suitcase"></i>
                    </span>
                    </div>
                    <p v-show="errors.has('taxId')" class="help is-danger">{{ errors.first('taxId') }}</p>
                </div>
                <div class="field" v-if="this.$store.state.dealer_portal.hasAccessCode">
                    <div class="control has-icons-left">
                        <input class="input" :class="{ 'is-danger' : errors.has('code') }" placeholder="Access Code" v-model="payload.accessCode" name="code" v-validate="'required|min:6'"/>
                        <span class="icon is-left">
                            <i class="fa fa-plug"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</p>
                </div>
                <button class="button is-primary is-block-button" :class="{ 'is-loading' : loading }">
                    Register
                </button>
                <div class="notification is-warning has-text-centered m-t-md" v-show="email_in_use">
                    That email address is already in use... Try <router-link :to="{ name : $ROUTES.LOGIN }">logging in or reseting your password</router-link>.
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import UserPublic from '@/api/UserPublic'
import _ from "underscore";

export default {
    name : 'signup',
    computed : {
        validation () {
            return {
                'required' : this.$store.state.dealer_portal.settings.require_business_information_on_sign_up,
            };
        },
    },
    data () {
        return {
            payload : {
                email : '',
                password : '',
                firstName : '',
                lastName : '',
                accessCode : '',
                taxId : null,
                companyName : null,
                phone : null,
                website : null,
                addressLine1 : null,
                addressLine2 : null,
                city : null,
                state : null,
                country : null,
                postal : null
            },
            loading : false,
            email_in_use : false,
        }
    },

    beforeCreate () {
        if (this.$store.state.session_context && this.$store.state.session_context.dealer && this.$store.state.session_context.dealer.id) {
            this.$router.push({ name : 'home' })
        }
    },

    methods : {
        register (event) {
            event.preventDefault()
            this.$validator.validateAll().then((result) => {
                if (!result) {
                    return;
                }
                this.loading = true;
                UserPublic.signup(this.payload).then((response) => {

                    if (!response.data.token) {
                        this.loading = false;
                        return
                    }

                    this.$store.commit('setSessionContext', response.data);
                    window.localStorage.setItem('token', response.data.token);
                    axios.defaults.headers.common['X-ACCESS-TOKEN'] = response.data.token;
                    this.$router.push('/')

                }, (response) => {

                    this.loading = false;

                    //Email exists
                    if(response.status === 409){
                        this.email_in_use = true;
                        this.$notify({
                            text : 'An account already exists for that email',
                            type : 'error',
                        })
                    }

                    if(response.status !== 401){
                        return;
                    }
                    if(this.$store.state.dealer_portal.hasAccessCode){
                        this.$notify({
                            text : 'Invalid Access Code',
                            type : 'error',
                        })
                    } else {
                        this.$notify({
                            text : 'You don\'t have permission to register for this supplier',
                            type : 'error',
                        })
                    }
                });
            });
        }
    },
}
</script>

<style lang="scss" scoped>
    .signup-form-con {
        width:320px;
    }
    .logo {
        margin-bottom:20px;
        img {
            max-height: 130px;
            max-width: 100%;
            width: auto;
            height: auto;
            margin:0 auto;
        }
    }
    .title {
        margin-bottom:20px;
    }
</style>
